import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppAuthState } from "../../hooks/use-app-auth-state";

import ContactLibrary from "../../components/ContactLibrary/ContactLibrary";
import CreateProjectForm from "../../components/CreateProjectForm/CreateProjectForm";
import LoadingMask from "../../components/LoadingMask/LoadingMask";
import ProjectList from "../../components/ProjectList/ProjectList";
import ReadOnlyField from "../../components/ReadOnlyField/ReadOnlyField";
import { useDocumentTitle } from "../../hooks/use-document-title";
import { useUserProfile } from "../../hooks/use-user-profile";
import "./AccountSettingsPage.scss";

const AccountSettingsPage: React.FC = () => {
  useDocumentTitle("Account Settings");

  const { fireUser, isLoggedIn, isAuthLoading } = useAppAuthState();
  const navigate = useNavigate();
  const { loading } = useUserProfile(fireUser?.uid);

  useEffect(() => {
    if (!isLoggedIn && !isAuthLoading) {
      navigate("/login");
    }
  }, [isLoggedIn, isAuthLoading, navigate]);

  if (!fireUser) {
    return null;
  }

  if (loading || isAuthLoading) {
    return <LoadingMask message="Loading account settings..." />;
  }

  return (
    <div className="account-home-page">
      <div className="page-header">Account</div>

      <div className="row">
        <div className="col-lg-8">
          <ContactLibrary />
          <ProjectList />
        </div>
        <div className="col-lg-4 sidebar">
          <div className="inner">
            <CreateProjectForm fireUser={fireUser} onSuccess={() => {}} />
            <section>
              <ReadOnlyField label="Email" value={fireUser.email} />
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettingsPage;
